<label>
  <input
    [type]="type()"
    [attr.name]="name()"
    [checked]="this.checked()"
    (change)="change($event)"
    [disabled]="disabled()"
  />
  <ng-content></ng-content>
</label>
